import React, { FC, useCallback, useEffect, useRef, useState } from 'react';

import { DateTime } from 'luxon';
import { ReactDatePickerProps } from 'react-datepicker';

import Datepicker from '@components/Datepicker';

import Calendar from '@assets/Icons/Calendar';
import XSm from '@assets/Icons/XSm';

import styles from './style.module.scss';

const DateFilter: FC<ReactDatePickerProps> = ({ selected, onChange, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const closeOpen = useCallback((e: any) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('mousedown', closeOpen);
    return () => window.removeEventListener('mousedown', closeOpen);
  }, [closeOpen]);

  return (
    <div className={styles.dropdownContainer}>
      <div className={styles.buttonGroup}>
        <div
          role="button"
          onMouseDown={(e) => e.stopPropagation()}
          onClick={() => setIsOpen((prev) => !prev)}
          className={`${selected ? styles.withValuehandleButton : ''} ${styles.handleButton} ${styles.button} ${isOpen ? styles.buttonMenuOpen : ''}`}
        >
          <Calendar size={20} />
          {`Updated from${selected ? `-${DateTime.fromJSDate(selected).toLocaleString(DateTime.DATE_SHORT, { locale: window.navigator.language })}` : ''}`}
        </div>
        {selected && (
          <div
            role="button"
            className={`${styles.clearButton} ${styles.button} `}
            onClick={() => {
              onChange(null, undefined);
            }}
          >
            <XSm size={20} />
          </div>
        )}
      </div>
      {isOpen && (
        <div className={styles.dropdownMenu} ref={menuRef}>
          <Datepicker
            maxDate={new Date()}
            selected={selected}
            onChange={(date, e) => {
              onChange(date, e);
              setIsOpen(false);
            }}
            {...rest}
          />
        </div>
      )}
    </div>
  );
};

export default DateFilter;
